import { render, staticRenderFns } from "./AlternativeActionsMessage.vue?vue&type=template&id=85891ad4&scoped=true"
import script from "./AlternativeActionsMessage.vue?vue&type=script&lang=ts"
export * from "./AlternativeActionsMessage.vue?vue&type=script&lang=ts"
import style0 from "./AlternativeActionsMessage.vue?vue&type=style&index=0&id=85891ad4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85891ad4",
  null
  
)

export default component.exports